import type { RichMediaLayout as MediaSingleLayout } from '@atlaskit/adf-schema';

// Layouts where the left handle is the only resize handle today.
// These must keep the left handle.
export const leftHandleOnlyLayouts: MediaSingleLayout[] = ['wrap-right', 'align-end'];
